<template>
  <div class="animated fadeIn">
    <b-form @submit.prevent="onSubmit">
      <instrument-identification-form
        :form_data="form_data"
        :runtime_options="runtime_options"
        @updateFormData="updateFormData"
      />
      <instrument-jig-form
        v-if="!instrument_id"
        :form_data="form_data"
        @updateFormData="updateFormData"
      />
      <b-row>
        <b-col>
          <instrument-form-analysis-cardstack
            :instrument="instrument"
            :instrument_tests="instrument_tests"
            @instrumentAnalysisClick="instrumentAnalysisClick"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-button
            @click="submitForm"
            class="my-4 float-right py-3 px-5"
            variant="success"
          >
            <i class="fal fa-address-book" /> Save
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
import InstrumentIdentificationForm from "./form/InstrumentIdentificationForm";
import InstrumentJigForm from "./form/InstrumentJigForm";
import InstrumentFormAnalysisCardstack from "@/components/lab/instrument/form/InstrumentFormAnalysisCardstack";
import InstrumentModel from "@/models/lab/InstrumentModel";

export default {
  name: "InstrumentForm",
  components: {
    InstrumentFormAnalysisCardstack,
    InstrumentIdentificationForm,
    InstrumentJigForm
  },
  props: {
    instrument: {
      type: Object,
      default: () => new InstrumentModel()
    }
  },
  data() {
    return {
      instrument_id: this.$route.params.instrument_id || null,
      form_data: {
        abbrev: null,
        capacity: 1,
        description: null,
        name: null,
        daily_capacity: 500,
        runtime: null,
        runtime_display: null,
        group_schedule: 0,
        instanceless_result: 0,
        jig_name: null,
        jig_capacity: 1,
        jig_x: 1,
        jig_y: 1,
        jig_z: 1
      },
      instrument_tests: [],
    };
  },
  methods: {
    updateFormData({ value, field }) {
      this.form_data[field] = value;
    },
    initFormData() {
      const runtime_options = InstrumentModel.formatRuntimeOptions();

      this.runtime_options = [
        {
          text: "Not selected",
          value: null
        },
        ...Object.keys(runtime_options).map(key => {
          return {
            text: runtime_options[key],
            value: key
          };
        })
      ];

      if (this.instrument_id) {
        this.form_data = {
          ...this.form_data,
          ...this.instrument.cloneAttributes(true, true)
        };
        this.instrument_tests = this.instrument.instrument_tests.map(
          test => test.analysis_id
        );
      }
    },
    submitForm() {
      const {
        abbrev,
        capacity,
        name,
        description,
        runtime,
        runtime_display,
        group_schedule,
        instanceless_result
      } = this.form_data;
      const payload = {
        abbrev,
        capacity,
        instrument_tests: this.instrument_tests,
        name,
        runtime,
        runtime_display
      };
      const jig = {
        name: this.form_data.jig_name,
        capacity: this.form_data.jig_capacity,
        x: this.form_data.jig_x,
        y: this.form_data.jig_y,
        z: this.form_data.jig_z
      };

      group_schedule && (payload.group_schedule = group_schedule);
      description && (payload.description = description);
      this.instrument.id && (payload.id = this.instrument.id);
      instanceless_result &&
        (payload.instanceless_result = instanceless_result);

      return this.$emit("submit", payload, jig);
    },
    instrumentAnalysisClick(state) {
      this.instrument_tests = state;
    }
  },
  created() {
    this.initFormData();
  }
};
</script>
